// src/graphql/mutations/assignNickname.js
import { gql } from '@apollo/client';

export const ASSIGN_NICKNAME = gql`
  mutation assignNickname($system_id: String!, $nickname: String!) {
    assignNickname(system_id: $system_id, nickname: $nickname) {
      result
    }
  }
`;

